import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from "sweetalert2";

const Steps6 = ({ count, setCount, detailsSet, details, initialData }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState();

  useEffect(() => {
    setFormData(details);
  }, [details]);

  // Handle input changes
  const handleInputChange = (e) => {
    const { name, value = "" } = e.target;
    if (!!name) {
      setFormData({ ...formData, [name]: value });
    }
  };


  const submitRegesterData = async () => {
    axios.post(`https://anoopam.com/aims/api/?action=member&format=new`, { payload: formData })
      .then((res) => {
        if (res?.status) {
          Swal.fire({
            text: `${res?.data?.message}`,
            icon: "success"
          });
          navigate('/members')
        } else {
          Swal.fire({
            text: `${res?.data?.message}`,
            icon: "error"
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          text: `${err?.data?.message}`,
          icon: "error"
        });
      })
  };


  const handleSubmit = (e) => {
    e.preventDefault();
    submitRegesterData();

  };

  const [services, setServices] = useState("");
  return (
    <form onSubmit={handleSubmit}>
      {/* <div className="stepProgrees text-start mt-2">
        <p className="d-flex tittle-text mb-0">
          <b style={{ color: "#034DA2" }} className="">
            Seva Skill
          </b>
        </p>
        <p style={{ color: "#034DA2" }} className="tittle-text mb-0">
          Seva Skill
        </p>
      </div> */}
      <div className="mt-4 p-4 border rounded-4  bg-white">
        <div className="row">
          <div className="tittle-text">
            Would you be eager to offer your seva as and when requested?{" "}
            <span className="fw-bold">
              તક ની સેવા હોય તો તમે ઝડપવા તૈયાર છો કે નહિ?
            </span>{" "}
            <div className="col-11 mt-3">
              <div className=" d-flex gap-3 flex-wrap">
                {/* <button
                  className={`btn button1 rounded-5 ${
                    services === "Yes" ? "active" : ""
                  }`}
                  onClick={() => setServices("yes")}
                >
                  Yes
                </button>
                <button
                  className={`btn rounded-5 button1 ${
                    services === "No" ? "active" : ""
                  }`}
                  onClick={() => setServices("No")}
                >
                  No
                </button>
                <button
                  className={`btn rounded-5 button1 ${
                    services === "May be" ? "active" : ""
                  }`}
                  onClick={() => setServices("May be")}
                >
                  May be
                </button> */}
                {["Yes", "No", "May be"].map((option, index) => (
                  <React.Fragment key={index}>
                    <input
                      hidden
                      type="radio"
                      name="optionStatus"
                      value={option}
                      // key={index}
                      id={`optionStatus-${index}`}
                      onChange={handleInputChange}
                    />
                    <label
                      htmlFor={`optionStatus-${index}`}
                      className={`btn rounded-5 button1 ${formData?.optionStatus === option ? "active" : ""
                        }`}
                    >
                      {option}
                    </label>
                  </React.Fragment>
                ))}
              </div>
            </div>
          </div>
          <div className="col-11 d-flex  gap-3   mt-4">
            <div className="d-flex align-items-center">
              <input type="checkbox" className="form-check-input" id="" />
              <label className="mx-2  tittle-text" htmlFor="">
                b12321123
              </label>
            </div>
          </div>

          {/* <div className="col-11 mt-3">
            <label className="tittle-text" htmlFor="dance">
              Dance
            </label>
            <div className="col-11 d-flex gap-4 flex-wrap mt-2">
              <div className="d-flex align-items-center">
                <input
                  className="form-check-input"
                  id="classical"
                  type="checkbox"
                />
                <label
                  className="classical tittle-text ms-2"
                  htmlFor="classical"
                >
                  Classical
                </label>
              </div>
              <div className="d-flex align-items-center">
                <input className="form-check-input" id="flok" type="checkbox" />
                <label className="flok tittle-text ms-2" htmlFor="flok">
                  Flok
                </label>
              </div>
              <div className="d-flex align-items-center">
                <input className="form-check-input" id="test" type="checkbox" />
                <label className="test tittle-text ms-2" htmlFor="test">
                  Test
                </label>
              </div>
            </div>
          </div> */}
          <div className="col-11 mt-3">
            <label className="tittle-text" htmlFor="dance">
              Dance
            </label>
            <div className="col-11 d-flex gap-4 flex-wrap mt-2">
              {["Classical", "Flok", "Test"].map((dance, index) => (
                <div className="d-flex align-items-center" key={index}>
                  {/* Checkbox Input */}
                  <input
                    type="checkbox"
                    className="form-check-input"
                    name="danceType"
                    value={dance}
                    id={`danceType-${index}`}
                    onChange={handleInputChange}
                  />
                  {/* Label for Checkbox */}
                  <label
                    className={`${dance} tittle-text ms-2`}
                    htmlFor={`danceType-${index}`}
                  >
                    {dance}
                  </label>
                </div>
              ))}
            </div>
          </div>

          {/* <div className="col-11  mt-3">
            <div>
              {" "}
              <label className="tittle-text" htmlFor="">
                Music
              </label>
            </div>
            <div className="col-11 d-flex gap-4 flex-wrap mt-2">
              <div className="d-flex align-items-center">
                <input
                  className="form-check-input"
                  id="classical"
                  type="checkbox"
                />
                <label
                  className="classical tittle-text ms-2"
                  htmlFor="classical"
                >
                  Classical
                </label>
              </div>
              <div className="d-flex align-items-center">
                <input className="form-check-input" id="rock" type="checkbox" />
                <label className="flok tittle-text ms-2" htmlFor="rock">
                  Rock
                </label>
              </div>
              <div className="d-flex align-items-center">
                <input
                  className="form-check-input"
                  id="skilltest"
                  type="checkbox"
                />
                <label className="test tittle-text ms-2" htmlFor="skilltest">
                  Skill test
                </label>
              </div>
            </div>
          </div> */}
          <div className="col-11 mt-3">
            <div>
              <label className="tittle-text" htmlFor="">
                Music
              </label>
            </div>
            <div className="col-11 d-flex gap-4 flex-wrap mt-2">
              {["Classical", "Rock", "Skill test"].map((music, index) => (
                <div className="d-flex align-items-center" key={index}>
                  <input
                    type="checkbox"
                    className="form-check-input"
                    name="musicType"
                    value={music}
                    id={`musicType-${index}`}
                    onChange={handleInputChange}
                  />
                  <label
                    className={`${music} tittle-text ms-2`}
                    htmlFor={`musicType-${index}`}
                  >
                    {music}
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-end gap-3 mt-3">
        {count !== 0 && (
          <button
            className="rounded-5 btnBlue"
            onClick={() => setCount(count - 1)}
          >
            Previous
          </button>
        )}
        {count < 6 && (
          <button
            className="rounded-5 btnBlue"
          // onClick={() => setCount(count + 1)}
          >
            Next
          </button>
        )}
        {/* <button
          className="rounded-5 btnBlue"
          onClick={handleSubmit}
          // onClick={() => setCount(count + 1)}
        >
          Next
        </button> */}
      </div>
    </form>
  );
};

export default Steps6;
